<script setup lang="ts">
const props = defineProps<{
  uspTemplate?: UspTemplate
}>()

const templatesConfig = {
  circle: {
    box: {
      width: '18%',
      aspectRatio: '1 / 1',
      backgroundColor: '#01B3FF',
      borderRadius: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '3%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
    },
    // Uncomment when using subtitle
    // subTitle: {
    //   fontWeight: 'normal',
    //   fontSize: '0.6rem',
    //   textAlign: 'center',
    //   color: 'white',
    // },
  },
  banner: {
    box: {
      width: 'fit-content',
      height: '10%',
      backgroundColor: '#01B3FF',
      boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.2)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'start',
      paddingRight: '5%',
      clipPath: 'polygon(0 0, 100% 0, 90% 100%, 0 100%)',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'start',
      justifyContent: 'start',
    },
    // Uncomment when using subtitle
    // subTitle: {
    //   fontWeight: 'normal',
    //   fontSize: '1.3rem',
    //   textAlign: 'start',
    //   color: 'white',
    //   whiteSpace: 'nowrap',
    //   overflow: 'hidden',
    // },
  },
}

const activeTemplate = computed(() => {
  const templateMap = {
    1: templatesConfig.circle,
    2: templatesConfig.banner,
  }

  const template = templateMap[props.uspTemplate?.templateId] || null

  // Uncomment when using subtitle
  // Adjust font sizes based on the presence of title and subtitle
  // if (template) {
  //   const hasTitle = !!props.uspTemplate?.title;
  //   const hasSubTitle = !!props.uspTemplate?.subTitle;

  //   if (hasTitle && !hasSubTitle) {
  //     // Only title is present → Increase title font size
  //     template.title.fontSize = '1.8rem';
  //   } else if (!hasTitle && hasSubTitle) {
  //     // Only subtitle is present → Increase subtitle font size
  //     template.subTitle.fontSize = '1.8rem';
  //   } else {
  //     // Both are present → Keep default sizes
  //     template.title.fontSize = templatesConfig.banner.title.fontSize;
  //     template.subTitle.fontSize = templatesConfig.banner.subTitle.fontSize;
  //   }
  // }

  return template
})

const getPositionStyles = () => {
  const position = props.uspTemplate?.position || 'bottom-left'

  const circlePositions = {
    'top-left': { top: '4%', left: '4%' },
    'top-right': { top: '4%', right: '4%' },
    'bottom-left': { bottom: '4%', left: '4%' },
    'bottom-right': { bottom: '4%', right: '4%' },
  }

  const bannerPositions = {
    'top-left': { top: '10%', left: '0px' },
    'bottom-left': { bottom: '0px', left: '0px' },
  }

  if (props.uspTemplate?.templateId == 1) {
    return circlePositions[position] || circlePositions['top-right']
  } else if (props.uspTemplate?.templateId == 2) {
    return bannerPositions[position] || bannerPositions['bottom-left']
  }

  return {}
}
</script>
<template>
  <div
    v-if="activeTemplate"
    class="usp-overlay"
    :style="{ ...activeTemplate.box, ...getPositionStyles() }"
  >
    <p
      v-if="props.uspTemplate?.title"
      class="usp-title"
      :style="activeTemplate.title"
    >
      {{ props.uspTemplate?.title }}
    </p>
    <!--
        <p v-if="props.uspTemplate?.subTitle" :style="activeTemplate.subTitle"> 
          {{ props.uspTemplate?.subTitle}}
        </p> 
      -->
  </div>
</template>

<style scoped>
.usp-overlay {
  position: absolute;
  z-index: 100;
}

.usp-title {
  font-weight: 600;
  letter-spacing: 0.01em;
  font-size: clamp(0.4rem, 5vw, 1.25rem);
  line-height: 1.233;
  color: white;
  width: 100%;
  height: 100%;
  margin: 4px;
}

.os-dialog .usp-overlay .usp-title {
  font-size: clamp(0.4rem, 5vw, 2rem);
}

.os-deal-card__image .usp-overlay .usp-title {
  font-size: 0.65rem !important ;
}

@media screen and (max-width: 470px) {
  .os-deal-card__image .usp-overlay .usp-title {
    font-size: 0.55rem !important ;
    margin: 2px !important;
  }
}

@media screen and (min-width: 590px) and (max-width: 1024px) {
  .os-deal-card__image .usp-overlay .usp-title {
    font-size: 0.85rem !important;
    margin: 3px !important;
  }
}

.swiper--thumbs .swiper-slide .usp-overlay .usp-title {
  font-size: 0.3rem;
  margin: 2px;
}
.swiper--dialog-thumbs .swiper-slide .usp-overlay .usp-title {
  font-size: 0.2rem;
  margin: 1.5px;
}
</style>
